import { useState } from "react"
import { Link } from "react-router-dom"
import { websiteAuthService } from "@/api/websiteAuthService"

export const ForgotPassword = () => {
  const [email, setEmail] = useState("")
  const [isSending, setIsSending] = useState(false)
  const [message, setMessage] = useState("")
  const [error, setError] = useState("")

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault()
    setIsSending(true)
    setMessage("")
    setError("")
    try {
      const response = await websiteAuthService.forgotPassword(email.trim())
      setMessage(response.message)
    } catch (error: any) {
      setError(
        error?.error?.email?.[0] ||
          error?.message ||
          "Unable to send a reset link. Please try again."
      )
    } finally {
      setIsSending(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4">
      <div className="max-w-md w-full space-y-6 bg-white p-8 rounded-xl shadow-md">
        <h1 className="text-3xl font-bold text-gray-900">Forgot password?</h1>
        <p className="text-sm text-gray-600">
          Enter your account email to receive a password reset link.
        </p>
        {message && (
          <p
            role="status"
            className="rounded-md bg-green-50 p-3 text-sm text-green-800"
          >
            {message} Check your inbox and spam folder.
          </p>
        )}
        {error && (
          <p
            role="alert"
            className="rounded-md bg-red-50 p-3 text-sm text-red-700"
          >
            {error}
          </p>
        )}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label
              htmlFor="reset-email"
              className="block text-sm font-medium text-gray-700"
            >
              Email address
            </label>
            <input
              id="reset-email"
              type="email"
              autoComplete="email"
              required
              maxLength={255}
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              disabled={isSending}
              className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
            />
          </div>
          <button
            type="submit"
            disabled={isSending}
            className="w-full rounded-md bg-indigo-600 px-4 py-2 text-white hover:bg-indigo-700 disabled:opacity-50"
          >
            {isSending ? "Sending..." : "Send reset link"}
          </button>
        </form>
        <Link
          to="/login"
          className="block text-center text-sm text-indigo-600 hover:text-indigo-500"
        >
          Back to login
        </Link>
      </div>
    </div>
  )
}
